import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "rel", "mode", "disabled", "href", "size", "loading", "onClick", "tabIndex", "component"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import classnames from 'classnames';
import omit from 'lodash/omit';
import has from 'lodash/has';
import pick from 'lodash/pick';
import { EmbersLoading } from '../loading';
import { StyledLink } from './linkStyles';
import { onEnterKeyPress } from '../utils/wcagUtils';
export var useLinkAriaLabel = function useLinkAriaLabel(props) {
  var intl = useIntl();

  // Support ButtonLink set aria-label = undefined
  var label = has(props, 'aria-label') ? props['aria-label'] : props.children;
  if (!label) {
    return void 0;
  }
  return props.target === '_blank' ? intl.formatMessage({
    id: 'embers.accessibility.opensNewPage.label',
    defaultMessage: '{link} (opens in new page)'
  }, {
    link: label
  }) : label;
};

// eslint-disable-next-line react/display-name
export var EmbersLink = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    rel = props.rel,
    _props$mode = props.mode,
    mode = _props$mode === void 0 ? 'white' : _props$mode,
    disabled = props.disabled,
    href = props.href,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    onClick = props.onClick,
    _props$tabIndex = props.tabIndex,
    tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
    _props$component = props.component,
    component = _props$component === void 0 ? 'a' : _props$component,
    otherProps = _objectWithoutProperties(props, _excluded);
  var target = otherProps['target'];
  var ariaLabel = useLinkAriaLabel(_objectSpread(_objectSpread({}, pick(otherProps, ['target', 'aria-label'])), {}, {
    children: children
  }));
  var handleKeyDown = function handleKeyDown(e) {
    onClick && onClick(e);
    if (href) {
      target === '_blank' ? window.open(href) : window.location.assign(href);
    }
  };
  return /*#__PURE__*/React.createElement(StyledLink, _extends({
    ref: ref,
    className: classnames('EmbersLink', _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "EmbersLink-".concat(size), size), 'EmbersLink-loading', loading), 'EmbersLink-disabled', disabled), 'EmbersLink-button', component === 'button'), className),
    rel: otherProps.target === '_blank' && !rel ? 'noreferrer' : rel,
    mode: mode,
    href: disabled || loading ? undefined : href,
    tabIndex: loading || disabled ? -1 : tabIndex,
    onClick: disabled || loading ? undefined : onClick,
    onKeyDown: function onKeyDown(e) {
      return onEnterKeyPress(e, handleKeyDown);
    },
    onKeyUp: function onKeyUp(e) {
      // prevents onclick event triggering when tab focus to it
      e.preventDefault();
    },
    as: component,
    "aria-label": disabled || loading ? undefined : ariaLabel
  }, omit(otherProps, ['aria-label', 'onKeyUp'])), loading && /*#__PURE__*/React.createElement(EmbersLoading, {
    size: "small",
    className: "EmbersLink-loading-icon"
  }), children);
});